import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useState, useEffect, useRef } from 'react';
import styled, { css } from 'styled-components';
import { AccordionContext } from './accordion.context';
import { AccordionItemContext } from './accordionItem.context';
const AccordionCollapseStyled = styled.div `
  ${({ open }) => css `
    visibility: ${!open ? 'hidden' : 'visible'};
    overflow: hidden;
    max-height: ${open ? '1200px' : '0'};
    transition: ${!open
    ? 'max-height 500ms cubic-bezier(0, 1, 0, 1)'
    : 'max-height 200ms ease-in-out'};
  `}
`;
export const AccordionCollapseAnimated = ({ children, ...rest }) => {
    const { disabled } = useContext(AccordionContext);
    const { open, itemDisabled } = useContext(AccordionItemContext);
    const [maxHeight, setMaxHeight] = useState(0);
    const ref = useRef(null);
    useEffect(() => {
        !disabled && open && setMaxHeight(ref.current.scrollHeight);
    }, [open]);
    const style = {
        maxHeight: open ? `${maxHeight}px` : 0,
    };
    return (_jsx(AccordionCollapseStyled, { "aria-hidden": !(disabled || open), ref: ref, style: !disabled ? style : { maxHeight: 'none' }, open: itemDisabled || disabled || open, ...rest, children: typeof children === 'string' ? (_jsx("div", { dangerouslySetInnerHTML: { __html: children } })) : (children) }));
};
//# sourceMappingURL=accordionCollapseAnimated.js.map